/**
 * Billing (Phase 21 / Task 21.7): Paelode's own invoicing of its customers. One nav entry,
 * a tab per area: Customers and Settings (21.7a), Rate cards (21.7b), Usage and Invoices
 * (21.7c), Payments and Aging (21.7d).
 *
 * Every route behind it needs MANAGE_PLATFORM_BILLING (PLATFORM_ADMIN only), the same people
 * this console admits at all, so the bar needs no per-tab gate.
 */
import * as React from 'react';
import { Navigate, NavLink, Route, Routes } from 'react-router-dom';
import { AgingPage } from './AgingPage';
import { BillingCustomersPage } from './BillingCustomersPage';
import { BillingSettingsPage } from './BillingSettingsPage';
import { CustomerBillingPage } from './CustomerBillingPage';
import { InvoiceDetailPage } from './InvoiceDetailPage';
import { InvoicesPage } from './InvoicesPage';
import { PaymentsPage } from './PaymentsPage';
import { RateCardDetailPage } from './RateCardDetailPage';
import { RateCardsPage } from './RateCardsPage';
import { UsagePage } from './UsagePage';
import { TAB_TRACK_STYLE, tabPillStyle } from 'src/components/ui/tab-styles';

const TABS: ReadonlyArray<{ path: string; label: string }> = [
  { path: '/billing/customers', label: 'Customers' },
  { path: '/billing/rate-cards', label: 'Rate cards' },
  { path: '/billing/usage', label: 'Usage' },
  { path: '/billing/invoices', label: 'Invoices' },
  { path: '/billing/payments', label: 'Payments' },
  { path: '/billing/aging', label: 'Aging' },
  { path: '/billing/settings', label: 'Settings' },
];

export function BillingPage(): React.JSX.Element {
  return (
    <div style={{ padding: '24px' }}>
      <nav aria-label="Billing" style={{ ...TAB_TRACK_STYLE, marginBottom: '20px' }}>
        {TABS.map((t) => (
          <NavLink
            key={t.path}
            to={t.path}
            style={({ isActive }): React.CSSProperties => tabPillStyle(isActive)}
          >
            {t.label}
          </NavLink>
        ))}
      </nav>
      <Routes>
        <Route path="customers" element={<BillingCustomersPage />} />
        <Route path="customers/:tenantId" element={<CustomerBillingPage />} />
        <Route path="rate-cards" element={<RateCardsPage />} />
        <Route path="rate-cards/:id" element={<RateCardDetailPage />} />
        <Route path="usage" element={<UsagePage />} />
        <Route path="invoices" element={<InvoicesPage />} />
        <Route path="invoices/:id" element={<InvoiceDetailPage />} />
        <Route path="payments" element={<PaymentsPage />} />
        <Route path="aging" element={<AgingPage />} />
        <Route path="settings" element={<BillingSettingsPage />} />
        <Route path="*" element={<Navigate to="/billing/customers" replace />} />
      </Routes>
    </div>
  );
}
